import { Component, computed, inject, signal } from '@angular/core';
import { RouterLink } from '@angular/router';

import {
  IconComponent,
  ScheduleMeetingComponent,
} from '@shared/lib/components';
import { AuthService, DerivedAuthService } from '@shared/lib/services';
import { environment } from 'projects/portal/src/environments/environment';

import { WAGTAILDATACONSTANTS } from '../../constants/wagtail-data';
import { AvatarComponent } from '../avatar/avatar.component';

type PlatformType = Exclude<
  keyof typeof WAGTAILDATACONSTANTS,
  'typeLink' | 'typeFolder' | 'field' | 'limit'
>;

@Component({
  selector: 'wu-profile-tray',
  imports: [
    IconComponent,
    RouterLink,
    AvatarComponent,
    ScheduleMeetingComponent,
  ],
  templateUrl: './profile-tray.component.html',

  styleUrl: './profile-tray.component.scss',
})
export class ProfileTrayComponent {
  private readonly authService = inject(AuthService);

  private readonly derivedAuthService = inject(DerivedAuthService);
  public showScheduleMeetModal = signal(false);
  platform: PlatformType = environment.platform as PlatformType;
  public scheduleAppointmentID =
    WAGTAILDATACONSTANTS[this.platform].scheduleAppointmentID;

  environmentDetails = environment;

  readonly user = computed(
    () => this.derivedAuthService.currentUserAuthentication()?.currentUser,
  );

  readonly studentId = this.derivedAuthService?.studentId;

  async logout() {
    await this.authService.logout();
  }

  public openSheduleMeet(event: any) {
    event.stopPropagation(); // prevent profile tray to close on the button click
    this.showScheduleMeetModal.set(true);
  }

  public closeModal() {
    this.showScheduleMeetModal.set(false);
  }
}
